"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1490))
 * @lastsynced 2026-10-29T13:52:28.596Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Minimize = createSVGIcon(
  <path
    d="m.857 23.143 8.572-8.571m0 6.857v-6.857H2.57M23.143.857l-8.571 8.571m0-6.856v6.856h6.857"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Minimize",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
